module.exports = __webpack_public_path__ + "img/diseño.3238c411.svg";